import { createFileRoute } from "@tanstack/react-router";
import { FavaComponent } from "@/pages/fava";
import { head, loader } from "@/pages/fava.meta";

export const Route = createFileRoute("/$locale/fava")({
  loader,
  head,
  component: FavaComponent,
});
